import { createSlice } from '@reduxjs/toolkit';

export const loginuserinfoSlice = createSlice({
  name: 'loginuserinfo', // Slice name
  initialState: {   
  }
  , // Initial state (empty array in this case)
  reducers: {
    setLoginuserinfo: (state, action) => {
      // Update the state with the received data
      return action.payload;
    },
  },
});

// Export the action creator
export const { setLoginuserinfo } = loginuserinfoSlice.actions;

// Export the reducer
export default loginuserinfoSlice.reducer;